// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__j6zO7","emails":"CreateEditClinics_emails__28k0G","emailTagLabel":"CreateEditClinics_emailTagLabel__2N9Nd"};